import { invalidateEntities, updateEntity } from 'components/Common/Data/DataFetcherEntitiesHelper';
import { trackButtonClicked } from 'components/Services/Analytics/TrackEventsService';
import { updateStore } from '../../Common/Data/DataFetcher';
import LeadSourcesApi from '../../../Resources/LeadSources/Api';
import {
  LEAD_SOURCES_PAGINATION_ID,
  NEW_FROM_LEAD_SOURCE_SETTINGS,
  NEW_FROM_CALL_TRACKING_NUMBERS_SETTINGS,
  NEW_FROM_JOB_DETAILS,
  NEW_FROM_ESTIMATE_DETAILS,
  NEW_FROM_CUSTOMER_DETAILS,
  NEW_FROM_NEW_JOB,
  NEW_FROM_NEW_ESTIMATE,
  NEW_FROM_NEW_CUSTOMER,
  NEW_FROM_NEW_CALL,
  NEW_FROM_LEAD_DETAILS,
  FOR_NEW_CALL,
  FOR_JOB,
  FOR_NEW_JOB,
  FOR_CUSTOMER,
  FOR_NEW_CUSTOMER,
  FOR_ESTIMATE,
  FOR_NEW_ESTIMATE,
  FOR_CALL_TRACKING_NUMBERS_SETTINGS,
  LEAD_SOURCE_NAME_SPACE,
  FOR_CUSTOMER_LIST,
  FOR_CUSTOMER_JOB_LIST,
  FOR_CUSTOMER_ESTIMATE_LIST,
  FOR_LEAD_DETAILS,
} from '../../../Resources/LeadSources/Data';
import { ENTITY_LEAD_SOURCES, ENTITY_LEAD_SOURCES_LIST } from '../../../Schema/LeadSourceSchema';
import {
  LEAD_SOURCE_DROP_DOWN_NAME,
  CREATE_LEAD_SOURCE_BUTTON_NAME,
  RESOURCE_TYPE_CUSTOMER,
  RESOURCE_TYPE_JOB,
  RESOURCE_TYPE_ESTIMATE,
  LEAD_SOURCE_CLEAR_BUTTON_NAME,
  RESOURCE_TYPE_BETA_ESTIMATES,
  RESOURCE_TYPE_JOBS,
} from './Constants';
import { CUSTOMER_NAMESPACE } from '../../Customers/Show/CustomerData';
import { JOB_NAMESPACE } from '../../../Resources/Job/JobData';

const invalidateLeadSourcesListCacheKey = (key) => (dispatch) =>
  dispatch(invalidateEntities(ENTITY_LEAD_SOURCES_LIST, key));

export const createLeadSource = (name) => (dispatch) =>
  LeadSourcesApi.create({ name }).then((res) => {
    dispatch(invalidateLeadSourcesListCacheKey(LEAD_SOURCES_PAGINATION_ID));
    return res.data;
  });

export const updateLeadSource = (name, uuid) => (dispatch) =>
  LeadSourcesApi.update({ name, uuid })
    .then((resp) => dispatch(appendUpdatedLeadSource(resp.data)))
    .then(() => dispatch(invalidateLeadSourcesListCacheKey(LEAD_SOURCES_PAGINATION_ID)));

const appendUpdatedLeadSource = (leadSource) => (dispatch) => {
  dispatch(updateEntity(leadSource.uuid, leadSource, ENTITY_LEAD_SOURCES));
};

export const deleteLeadSource = (uuid, searchQuery) => (dispatch) =>
  LeadSourcesApi.delete(uuid)
    .then(() => dispatch(invalidateLeadSourcesListCacheKey(LEAD_SOURCES_PAGINATION_ID)))
    .then(() => dispatch(invalidateLeadSourcesListCacheKey(searchQuery)));

const attachLeadSource = (resourceType, leadSourceUuid, sourceUuid) =>
  LeadSourcesApi.attach({ leadSourceUuid, sourceUuid, resourceType });

export const bulkAttachLeadSource = (resourceType, leadSourceUuid, sourceUuids) =>
  LeadSourcesApi.bulkAttach({ [resourceType]: sourceUuids, lead_source_uuid: leadSourceUuid })

export const bulkDetachLeadSources = (resourceType, sourceUuids) =>
  LeadSourcesApi.bulkDetach({ [resourceType]: sourceUuids })

export const attachLeadSourceToCustomer = (leadSourceUuid, sourceUuid) => (dispatch) =>
  attachLeadSource(RESOURCE_TYPE_CUSTOMER, leadSourceUuid, sourceUuid).then((response) => {
    updateStore(LEAD_SOURCE_NAME_SPACE, response.data, CUSTOMER_NAMESPACE, dispatch);
    return response;
  });

export const attachLeadSourceToJob = (leadSourceUuid, sourceUuid) => (dispatch) =>
  attachLeadSource(RESOURCE_TYPE_JOB, leadSourceUuid, sourceUuid).then((response) => {
    updateStore(LEAD_SOURCE_NAME_SPACE, response.data, JOB_NAMESPACE, dispatch);
    return response;
  });

export const attachLeadSourceToEstimate = (leadSourceUuid, sourceUuid) => (dispatch) =>
  attachLeadSource(RESOURCE_TYPE_ESTIMATE, leadSourceUuid, sourceUuid).then((response) => {
    updateStore(LEAD_SOURCE_NAME_SPACE, response.data, JOB_NAMESPACE, dispatch);
    return response;
  });

export const bulkAttachLeadSourceToEstimates = (leadSourceUuid, sourceUuids) => () =>
  bulkAttachLeadSource(RESOURCE_TYPE_BETA_ESTIMATES, leadSourceUuid, sourceUuids).then((response) => response);

export const bulkDetachLeadSourceToEstimates = (sourceUuids) => () =>
  bulkDetachLeadSources(RESOURCE_TYPE_BETA_ESTIMATES, sourceUuids).then((response) => response);

const detachLeadSource = (resourceType, sourceUuid) => LeadSourcesApi.detach({ sourceUuid, resourceType });

export const detachLeadSourceFromCustomer = (sourceUuid) => (dispatch) =>
  detachLeadSource(RESOURCE_TYPE_CUSTOMER, sourceUuid).then((response) => {
    updateStore(LEAD_SOURCE_NAME_SPACE, null, CUSTOMER_NAMESPACE, dispatch);
    return response;
  });

export const detachLeadSourceFromJob = (sourceUuid) => (dispatch) =>
  detachLeadSource(RESOURCE_TYPE_JOB, sourceUuid).then((response) => {
    updateStore(LEAD_SOURCE_NAME_SPACE, null, JOB_NAMESPACE, dispatch);
    return response;
  });

export const detachLeadSourceFromEstimate = (sourceUuid) => (dispatch) =>
  detachLeadSource(RESOURCE_TYPE_ESTIMATE, sourceUuid).then((response) => {
    updateStore(LEAD_SOURCE_NAME_SPACE, null, JOB_NAMESPACE, dispatch);
    return response;
  });

export const bulkAttachLeadSourceToJobs = (leadSourceUuid, sourceUuids) => () =>
  bulkAttachLeadSource(RESOURCE_TYPE_JOBS, leadSourceUuid, sourceUuids).then((response) => response);

export const bulkDetachLeadSourceToJobs = (sourceUuids) => () =>
  bulkDetachLeadSources(RESOURCE_TYPE_JOBS, sourceUuids).then((response) => response);

const buttonClicked = (buttonName, buttonLabel) => () => (dispatch) => {
  dispatch(
    trackButtonClicked(buttonName, {
      button_label: buttonLabel,
    })
  );
};
export const saveFromLeadSourceSettings = buttonClicked(NEW_FROM_LEAD_SOURCE_SETTINGS, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromCallTrackingNumbersSettings = buttonClicked(
  NEW_FROM_CALL_TRACKING_NUMBERS_SETTINGS,
  CREATE_LEAD_SOURCE_BUTTON_NAME
);
export const saveFromJobDetails = buttonClicked(NEW_FROM_JOB_DETAILS, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromEstimateDetails = buttonClicked(NEW_FROM_ESTIMATE_DETAILS, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromCustomerDetails = buttonClicked(NEW_FROM_CUSTOMER_DETAILS, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromCreateNewJob = buttonClicked(NEW_FROM_NEW_JOB, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromCreateNewEstimate = buttonClicked(NEW_FROM_NEW_ESTIMATE, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromCreateNewCustomer = buttonClicked(NEW_FROM_NEW_CUSTOMER, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromCreateNewCall = buttonClicked(NEW_FROM_NEW_CALL, CREATE_LEAD_SOURCE_BUTTON_NAME);
export const saveFromLeadDetails = buttonClicked(NEW_FROM_LEAD_DETAILS, CREATE_LEAD_SOURCE_BUTTON_NAME);

export const interactFromCreateNewCustomer = buttonClicked(FOR_NEW_CUSTOMER, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCustomerDetails = buttonClicked(FOR_CUSTOMER, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCreateNewEstimate = buttonClicked(FOR_NEW_ESTIMATE, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromEstimateDetails = buttonClicked(FOR_ESTIMATE, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCreateNewJob = buttonClicked(FOR_NEW_JOB, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromJobDetails = buttonClicked(FOR_JOB, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCreateNewCall = buttonClicked(FOR_NEW_CALL, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCallTrackingNumbersSettings = buttonClicked(
  FOR_CALL_TRACKING_NUMBERS_SETTINGS,
  LEAD_SOURCE_DROP_DOWN_NAME
);
export const interactFromCustomersTable = buttonClicked(FOR_CUSTOMER_LIST, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCustomerJobTable = buttonClicked(FOR_CUSTOMER_JOB_LIST, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromCustomerEstimateTable = buttonClicked(FOR_CUSTOMER_ESTIMATE_LIST, LEAD_SOURCE_DROP_DOWN_NAME);
export const interactFromLeadDetails = buttonClicked(FOR_LEAD_DETAILS, LEAD_SOURCE_DROP_DOWN_NAME);

export const trackClearedFromCustomerDetails = buttonClicked(FOR_CUSTOMER, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromJobDetails = buttonClicked(FOR_JOB, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromEstimateDetails = buttonClicked(FOR_ESTIMATE, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromCreateNewCustomer = buttonClicked(FOR_NEW_CUSTOMER, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromCreateNewJob = buttonClicked(FOR_NEW_JOB, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromCreateNewEstimate = buttonClicked(FOR_NEW_ESTIMATE, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromCreateNewCall = buttonClicked(FOR_NEW_CALL, LEAD_SOURCE_CLEAR_BUTTON_NAME);
export const trackClearedFromCallTrackingNumbersSettings = buttonClicked(
  FOR_CALL_TRACKING_NUMBERS_SETTINGS,
  LEAD_SOURCE_CLEAR_BUTTON_NAME
);

export const trackClearedFromLeadDetails = buttonClicked(FOR_LEAD_DETAILS, LEAD_SOURCE_CLEAR_BUTTON_NAME);
